import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconEmail2Unread: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconEmail2Unread"><Path d="M22 6.63574C22 7.20066 21.6825 7.71797 21.1787 7.97363L13.1318 12.0576C12.4207 12.4185 11.5793 12.4185 10.8682 12.0576L3 8.06348V17.5C3 18.3284 3.67157 19 4.5 19H11.5C11.7761 19 12 19.2239 12 19.5C12 19.7761 11.7761 20 11.5 20H4.5C3.11929 20 2 18.8807 2 17.5V6.5C2 5.11929 3.11929 4 4.5 4H19.5C20.8807 4.00001 22 5.11929 22 6.5V6.63574Z" fill="currentColor"/><Circle cx="19.5" cy="17.5" r="3.5" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2Unread;
